
	import { formatDateTime, formatDecimalValue } from "@/domain/entities/EntityFields";
	import { defineComponent } from "vue";

	export default defineComponent({
		name: "patient-card",
		props: {
			patient: Object,
		},
		setup() {
			return {
				formatDateTime,
        formatDecimalValue,
			};
		},
	});
